import { Button, CircularProgress, IconButton } from "@mui/material";
import styles from "./DocumentDownload.module.scss";
import MainContext from "../../context/mainContext";
import documentsService from "../../services/document.service";
import { useContext, useState } from "react";
import { DocumentIcon } from "../../assets/icons";
import { LanguageDocument } from "../../models/workflow.model";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { useTranslation } from "react-i18next";

interface Props {
  documents: LanguageDocument[];
}

const DocumentDownloadMultiple: React.FC<Props> = ({ documents }) => {
  const { service } = useContext(MainContext);
  const { t } = useTranslation();
  const [downloading, setDownloading] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDownload = (documentId: number) => {
    setAnchorEl(null);
    download(documentId);
  };

  const download = (documentId: number) => {
    service(() => documentsService.download(documentId), {
      loader: setDownloading,
    });
  };

  return downloading ? (
    <CircularProgress className={styles.circular} />
  ) : (
    <div>
      <IconButton
        onClick={(e) => {
          e.stopPropagation();
          handleClick(e);
        }}
      >
        <DocumentIcon />
      </IconButton>
      <Menu anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleClose}>
        {documents.map((item, index) => (
          <MenuItem key={index} onClick={(e) => handleDownload(item.documentId)}>
            {t(`languages.${item.langCode}`)}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};

export default DocumentDownloadMultiple;
